import React from 'react'
import { Link } from 'gatsby'
import FooterTermsMenu from '../components/footer-terms-menu'
import styles from './footer.module.scss'


export default () => (
  <FooterTermsMenu />
)
